export enum MassParameter {
  MASS = "mass",
  TARGET_DENSITY = "targetDensity",
  OVERPACKING_FACTOR = "overpacking_factor",
}
